import { render, staticRenderFns } from "./SendEmailButton.vue?vue&type=template&id=4b2339fd&scoped=true&"
import script from "./SendEmailButton.vue?vue&type=script&lang=ts&"
export * from "./SendEmailButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2339fd",
  null
  
)

export default component.exports